// Administração > Conta & Integrações > Comandos GT06. Backend próprio
// (2026-09-01), mesma permissão granular de Integrações/Contrato/Planos
// (administracao.conta_integracoes). Catálogo por empresa de comandos GT06
// (texto bruto do protocolo + senha opcional) usado como atalho extra no
// popup "Enviar comando" (VehicleSendCommandDialog), além dos padrões
// Bloquear/Desbloquear.
import { gpsDriveDelete, gpsDriveGet, gpsDrivePost, gpsDrivePut } from "@/lib/api/gpsdrive-client";

// Fallback SMS automático (pedido 2026-09-06) — qual entrada do catálogo é
// usada quando Bloquear/Desbloquear falha por GPRS (offline ou erro do
// Traccar). Só 1 comando da empresa pode ter cada papel (ver backend).
export type Gt06CommandSmsFallbackRole = "block" | "unblock";

export interface Gt06Command {
  id: string;
  name: string;
  commandText: string;
  password: string | null;
  description: string | null;
  // Protocolo pro qual este comando é válido (pedido 2026-09-07) — sempre
  // presente (obrigatório no backend desde essa data). Ver
  // TRACKER_PROTOCOL_OPTIONS em @/lib/tracker-protocols.
  protocol: string;
  smsFallbackRole: Gt06CommandSmsFallbackRole | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertGt06CommandInput {
  name: string;
  commandText: string;
  password?: string | null;
  description?: string | null;
  protocol: string;
  smsFallbackRole?: Gt06CommandSmsFallbackRole | null;
}

export const gt06CommandsService = {
  list: () => gpsDriveGet<Gt06Command[]>("/api/v1/admin/gt06-commands"),
  create: (input: UpsertGt06CommandInput) => gpsDrivePost<Gt06Command>("/api/v1/admin/gt06-commands", input),
  update: (id: string, input: UpsertGt06CommandInput) =>
    gpsDrivePut<Gt06Command>(`/api/v1/admin/gt06-commands/${id}`, input),
  remove: (id: string) => gpsDriveDelete<void>(`/api/v1/admin/gt06-commands/${id}`),
};
